<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="i_gsid" :label="$t('form_company')" required>

                <el-select :disabled="canEdit" style="width: 200px" @change="changegs"  class="marr4" v-model="formData.i_gsid" size="small" clearable filterable :placeholder="$t('form_please_select_a_company')">
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="flex">
                <el-form-item  prop="i_khid" :label="data.c_type==1?$t('form_pustomer'):$t('form_supplier')" required>
                    <el-select style="width: 200px" @change="changekh" class="marr4" v-model="formData.i_khid" size="mini" clearable remote :remote-method="remoteMethodkh" filterable :placeholder="data.c_type==1?$t('collectPayment_pay_please_select_a_customer'):$t('collectPayment_pay_please_select_a_supplier')">
                        <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="i_sktype" :label="$t('collectPayment_pay_customer_accounts_receivable')">{{formData.f_pendingamount}}</el-form-item>
            </div>
            <el-form-item  prop="vc_bank_account" required :label="$t('collectPayment_pay_bank_account_number')"  v-if="formData.i_isbankcharges===0">

                <el-select :disabled="canEdit" style="width: 200px"  @change="changeyhzh" class="marr4" v-model="formData.vc_bank_account" size="small" clearable filterable :placeholder="$t('collectPayment_pay_please_select_a_bank_account_number')">
                    <el-option v-for="item in yhzhList" :key="item.vc_bank_account" :label="item.vc_bank_account" :value="item.vc_bank_account">
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item  prop="vc_keyname" label="客户" required>-->
<!--                <el-select style="width: 200px" v-if="data.type==2" class="marr4" v-model="formData.i_khid" size="small" clearable filterable placeholder="请选择客户">-->
<!--                    <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item  prop="vc_keyname" label="供应商" required>-->
<!--                <el-select style="width: 200px" v-if="data.type==1" class="marr4" v-model="formData.gysid" size="small" clearable filterable placeholder="请选择供应商">-->
<!--                    <el-option v-for="item in gysList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item  prop="i_sktype" :label="$t('collectPayment_pay_type')" required>
                <el-select :disabled="canEdit"  style="width: 200px" class="marr4" v-model="formData.i_sktype" size="small"  :placeholder="$t('collectPayment_pay_please_select_a_type')">
                    <el-option v-for="item in dhcdList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="i_isbankcharges" :label="$t('collectPayment_pay_expense_type')" required>
                <el-radio-group :disabled="canEdit" v-model="formData.i_isbankcharges" @input="changeFY">
                    <el-radio :label='0'>{{$t('collectPayment_pay_bank_statement')}}</el-radio>
                    <el-radio :label='1'>{{$t('collectPayment_pay_handling_fee')}}</el-radio>
                    <el-radio :label='2'>{{$t('collectPayment_pay_goods_offset_payment')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <div class="flex">
                <el-form-item  prop="i_bzid" :label="$t('form_currency')" required>
<!--                    <span v-if="formData.i_isbankcharges===0">{{formData.vc_bzname}}</span>-->
                    <el-select  v-if="formData.i_isbankcharges===0" @change="changeData($event,'bz')" :disabled="canEdit" style="width: 100px"   class="marr4" v-model="formData.i_bzid" size="small"  filterable :placeholder="$t('collectPayment_pay_please_select_currency')">
                        <el-option
                                v-for="item in bzList"
                                :key="item.i_bzid"
                                :label="item.vc_bzname"
                                :value="item.i_bzid">
                        </el-option>
                    </el-select>
                    <el-select  v-else :disabled="canEdit"  style="width: 100px"  class="marr4" @change="changeDatabz($event,'bz')" v-model="formData.i_bzid" size="small"  filterable :placeholder="$t('collectPayment_pay_please_select_currency')">
                        <el-option
                                v-for="item in bzList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="f_rate" :label="$t('form_exchange_rate')" required>
                    <el-input-number :disabled="canEdit" class="changeinput" :controls="false"  size="mini" v-model="formData.f_rate" ></el-input-number>
                </el-form-item>
                <el-form-item  prop="f_pay" :label="$t('form_amount')" required>
                    <el-input-number :disabled="canEdit" class="changeinput" :controls="false" :precision="2"  size="mini" v-model="formData.f_pay" ></el-input-number>
                </el-form-item>
            </div>
            <!--<el-form-item  prop="i_isbankcharges" label="手续费" required>
                <el-radio-group v-model="formData.i_isbankcharges" >
                    <el-radio :label='0'>否</el-radio>
                    <el-radio :label='1'>是</el-radio>
                </el-radio-group>
            </el-form-item>-->
            <el-form-item  prop="vc_note" :label="$t('form_notes')">
                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.vc_note"  ></el-input>
            </el-form-item>
            <el-form-item  prop="dt_paytime" :label="$t('collectPayment_pay_payment_date')" required>
<!--                <span>{{formData.dt_paytime}}</span>-->
                <el-date-picker :disabled="canEdit"
                        v-model="formData.dt_paytime"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :placeholder="$t('form_select_date')"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_entry_date')" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" >{{$t('button_save')}}</el-button>
            </template>

            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                startTime:'',
                pickerOptions: {
                    // disabledDate(time) {
                    //     let curDate=(new Date()),perM;
                    //     if(curDate.getMonth()>0){
                    //         perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                    //     }else{
                    //         perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                    //     }
                    //     let today=(new Date()).getDate();
                    //     let same=today*24*3600*1000;
                    //     // let sameMonth=curDate-same;//当月月初
                    //     let sameMonth=perM;
                    //     return time.getTime() > Date.now() || time.getTime() < sameMonth;
                    //     // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                    //     // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的
                    // }
                },
                baseerp:'',
                canEdit:false,
                formData:{
                    i_gsid:'',
                    vc_bank_account:'',
                    i_khid:'',
                    i_sktype:3,
                    i_bzid:null,
                    vc_bzname:null,
                    f_rate:null,
                    f_pay:'',
                    dt_paytime:'',
                    i_isbankcharges:0,
                    vc_note:'',
                },
                gsList:[],
                yhzhList:[],
                khList:[],
                gysList:[],
                dhcdList:[{i_id:2,vc_name:this.$t('collectPayment_pay_acceptance')},{i_id:3,vc_name:this.$t('collectPayment_pay_telegraphic_transfer')}],
                tableHeight:0,
                searchkh:'',
                bzList:[],
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        if(this.i_id==0){
                            this.canEdit=false;
                            this.formData.i_id=this.i_id;
                            this.formData.c_type=this.data.c_type;
                            this.formData.dt_paytime=this.getDateYYYYMMddHHMMSS();
                            this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");

                        }else{
                            this.formData=JSON.parse(JSON.stringify(this.data));
                            this.formData.vc_bank_account=this.data.vc_gsaccount
                            this.formData.vc_name_bank=this.data.vc_khname
                            this.canEdit=true;
                            if(this.formData.i_isbankcharges==1||this.formData.i_isbankcharges==2){
                                this.getbzlist()
                            }
                            if(this.formData.i_isbankcharges==0&&this.formData.vc_bank_account){
                                this.getBzByBankAccount()
                            }
                        }
                        // console.log(this.fo,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getKhlistWithNoRights();
            this.getCompanyList();
            // this.getbzlist();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            saveForm(){
                if(this.formData.i_khid==''||this.formData.i_khid==undefined||this.formData.i_gsid==''||(this.formData.i_isbankcharges===0&&this.formData.vc_bank_account=='')||this.formData.f_pay==0||this.formData.f_rate==0){
                    this.$message.warning(this.$t('collectPayment_pay_please_fill_in_the_required_fields'))
                }else{
                    this.disabled=true
                    if(this.formData.i_id==0){
                        this.savePayment()

                    }else{
                        this.formData.i_cid=this.formData.i_khid
                        this.formData.vc_cname=this.formData.vc_khname

                        this.updateHistoryPayment()
                    }
                }

            },
            cancel(){
                this.$emit('close')
            },
            changekh(){
                this.formData.f_pendingamount='';
                if(this.formData.i_khid) {
                    let gsobj=this.khList.find(gs => gs.i_id == this.formData.i_khid)
                    this.formData.vc_khname = gsobj.vc_name;
                    this.formData.vc_type = gsobj.vc_type;
                    if(this.formData.i_gsid&&this.formData.vc_bank_account&&this.formData.i_bzid) {
                        this.getPendingAmounts()
                    }
                }
            },
            changegs(){
                this.formData.vc_bank_account='';
                this.formData.f_pendingamount='';
                this.yhzhList=[];
                if(this.formData.i_gsid){
                    this.formData.vc_gsname=this.gsList.find(gs=>gs.i_id==this.formData.i_gsid).vc_name;
                    this.startTime=this.gsList.find(gs=>gs.i_id==this.formData.i_gsid).lastCheckOutDate;
                    this.setDatePickerOptions();
                    this.getAccountByGsid()
                    if(this.formData.i_khid&&this.formData.vc_bank_account&&this.formData.i_bzid) {
                        this.getPendingAmounts()
                    }
                }
            },
            setDatePickerOptions() {
                let next;
                this.pickerOptions = {
                    disabledDate: (time) => {
                        if (!this.startTime) {
                            return time.getTime() > Date.now();
                        }

                        // 获取 startTime 的后一天
                        const startDate = new Date(this.startTime);
                        startDate.setDate(startDate.getDate() + 1);
                        const nextDay = new Date(
                            startDate.getFullYear(),
                            startDate.getMonth(),
                            startDate.getDate(),
                            0, 0, 0, 0
                        ).getTime();
                        next=nextDay;
                        // 获取今天的 00:00:00
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const todayStart = today.getTime();


                        // 禁用：今天之后的日期 和 startTime 后一天之前的日期
                        return time.getTime() > todayStart || time.getTime() < nextDay;
                    }
                };
                if( new Date(this.formData.dt_paytime).getTime()<next){
                    this.$set(this.formData,'dt_paytime',this.getDateYYYYMMddHHMMSS())
                }
            },
            changeyhzh(e){
                //console.log(e,'eeeeebank')
                if(e&&this.formData.i_isbankcharges==0){
                    this.formData.i_bzid=null;
                    this.getBzByBankAccount()
                }

            },

            remoteMethodkh(val){
                this.searchkh=val
                this.getKhlistWithNoRights()
            },
            async getKhlistWithNoRights(){
                let param={
                    i_khtype:'2,3,4,5,6,7,8',
                    currentPage:1,
                    pageSize: 50,
                    vc_search: this.searchkh,
                };
                let res=await API.getKhlistWithNoRights(param);
                if ( res.code == 1 ){
                    this.khList=res.data.list
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getAccountByGsid(){
                let param={
                    i_gsid:this.formData.i_gsid,
                };
                let res=await API.getAccountByGsid(param);
                if ( res.code == 1 ){
                    this.yhzhList=res.data.accountList;


                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getPendingAmounts(){
                let param={
                    i_gsid:this.formData.i_gsid,
                    i_khid:this.formData.i_khid,
                    i_bzid:this.formData.i_bzid,
                    c_type:this.formData.c_type
                };
                let res=await API.getPendingAmounts(param);
                if ( res.code == 1 ){
                    this.formData.f_pendingamount=res.data;
                    this.$forceUpdate()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type) {
                //console.log(e,type)
                if (type == 'bz') {
                    this.formData.i_bzid = e;
                    let choo = this.bzList.filter(item => {
                        return item.i_bzid == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_bzname = choo[0].vc_bzname;
                        this.formData.f_rate = choo[0].f_rate;
                    } else {
                        this.formData.vc_bzname = '';
                        this.formData.i_bzid = null;
                        this.formData.f_rate = 0;
                    }
                }
            },
            changeDatabz(e,type) {
                //console.log(e,type)
                if (type == 'bz') {
                    this.formData.i_bzid = e;
                    let choo = this.bzList.filter(item => {
                        return item.i_id == e
                    });
                    if (choo.length > 0) {
                        this.formData.vc_bzname = choo[0].vc_name;
                        this.formData.f_rate = choo[0].f_rate;
                    } else {
                        this.formData.vc_bzname = '';
                        this.formData.i_bzid = null;
                        this.formData.f_rate = 0;
                    }
                }
            },
            changeFY(e){
                this.formData.i_isbankcharges=e;
                this.bzList=[]
                this.formData.vc_bzname = '';
                this.formData.i_bzid = null;
                this.formData.f_rate = 0;
                if(e==1||e==2){
                    this.formData.vc_bank_account=''
                    this.getbzlist()
                }
                if(e==0&&this.formData.vc_bank_account){
                    this.getBzByBankAccount()
                }
                // if(e==2){
                //     this.getbzlist()
                // }
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                    let choo=this.bzList;
                    if(!this.canEdit) {
                        if (choo.length > 0) {
                            this.formData.vc_bzname = choo[0].vc_name;
                            this.formData.i_bzid = choo[0].i_id;
                            this.formData.f_rate = choo[0].f_rate;
                        } else {
                            this.formData.vc_bzname = '';
                            this.formData.i_bzid = null;
                            this.formData.f_rate = 0;
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getBzByBankAccount(){
                let param={
                    vc_bank_account:this.formData.vc_bank_account,
                };
                let res=await API.getBzByBankAccount(param);
                if ( res.code == 1 ){
                    this.bzList=res.data
                    if(!this.canEdit) {
                        this.formData.i_bzid = res.data[0].i_bzid;
                        this.formData.vc_bzname = res.data[0].vc_bzname;
                        this.formData.f_rate = res.data[0].f_rate;
                        this.formData.f_pendingamount = '';
                        if (this.formData.vc_bank_account && this.formData.i_bzid) {
                            if (this.formData.i_khid) {
                                this.getPendingAmounts()
                            }
                        }
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async savePayment(){
                let param=this.formData;
                let res=await API.savePayment(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            async updateHistoryPayment(){
                let param={
                    i_id:this.formData.i_id,
                    i_cid:this.formData.i_cid,
                    i_gsid:this.formData.i_gsid,
                    vc_gsaccount:this.formData.vc_gsaccount,
                    vc_cname:this.formData.vc_cname,
                    vc_name_bank:this.formData.vc_name_bank,
                    i_hpstatus:this.formData.i_hpstatus,
                    vc_type:this.formData.vc_type,
                    c_type:0,

                };
                let res=await API.updateHistoryPayment(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>